import { render, staticRenderFns } from "./testCF.vue?vue&type=template&id=c50c90fa&"
import script from "./testCF.vue?vue&type=script&lang=js&"
export * from "./testCF.vue?vue&type=script&lang=js&"
import style0 from "./testCF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports